<template>
  <div
    class="w-100 p-3 main-bg d-flex justify-content-center carousel-main-height-wrapper mt-3 mt-lg-2"
    :style="[
      desktop
        ? {
            'background-size': 'cover',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            background: `url(${backgroundImgDesktop})`,
          }
        : {
            'background-size': 'cover',
            'background-position': 'top left',
            'background-repeat': 'no-repeat',
            background: `url(${backgroundImgMobile})`,
          },
    ]"
  >
    <div
      class="container-fluid px-1 px-md-2 position-relative section-padding"
      :style="[hover && { 'z-index': '1111111 !important' }]"
    >
      <div class="row align-items-center mb-2">
        <div class="col-8 text-left px-0">
          <div class="w-100">
            <span class="carousel_title">{{ title }}</span>
          </div>
        </div>
        <div class="col-4">
          <div class="d-flex justify-content-end" @click="viewMore()">
            <span class="carousel_more cursor-pointer">View All</span>
          </div>
        </div>
      </div>
      <div class="row latest-video-content force-margin-auto" id="sponsorRails">
        <div class="owl-carousel owl-theme" :id="titleCarousel">
          <div
            class="item"
            v-for="item_vod in items"
            :key="titleCarousel + ' - ' + item_vod.id"
            @mouseover="mouseOver"
            @mouseout="mouseOver"
          >
            <vod-card
              :image="imgFiltering(item_vod)"
              :title="item_vod.longTitle"
              :description="item_vod.data.description"
              :link="checkLink(item_vod)"
              :category="item_vod.data.content_type[0].title.en_US"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Vue from "vue";
import axios from "axios";
import noimage from "../../assets/noimage.png";
import vodCard from "../cards/vodCard.vue";
export default {
  name: "sponsor-rails",
  props: ["title", "datasource", "cat", "cat_id"],
  data: function() {
    return {
      items: [],
      titleCarousel: this.title.replace(/\s/g, "").toLowerCase(),
      noimage: noimage,
      showMore: false,
      contenttype: this.datasource,
      hover: false,
      backgroundImgDesktop: "",
      backgroundImgMobile: "",
      mobile: false,
      desktop: false,
    };
  },
  components: { vodCard },
  methods: {
    mouseOver: function() {
      this.hover = !this.hover;
    },

    imageLoadError(event) {
      event.target.src = noimage;
    },
    viewMore() {
      var itemToPass = this.items;
      var contenttype = this.contenttype;

      this.$router.replace(
        "/viewall?cat=" +
          this.cat +
          "&cat_id=" +
          this.cat_id +
          "&contenttype=" +
          contenttype
      );
    },
    goTo(link) {
      this.$router.push(link);
    },
    checkLink(item) {
      var idSchema;
      var link;

      if (item.idSchema == "205" || item.idSchema == "206") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "205") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "207") {
        //news
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "208") {
        //vod
        link =
          "/play?scheme=" +
          item.idSchema +
          "&p_type=true&id=" +
          item.id +
          "&eps_id=";
      } else if (item.idSchema == "209") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/play?scheme=209&p_type=false&id=" + item.id + "&eps_id=";
      } else if (item.idSchema == "203") {
        //news
        idSchema = "209";
        // console.log(JSON.stringify(item, null, 2));
        link = "/podcastplayer?id=" + item.id;
      } else if (idSchema == "204") {
        //pod episode
        link = "/podcastplayer?id=" + item.id;
      }

      return link;
    },
    checkIndexForMore() {
      var listlength = this.items;
      if (listlength.length > 8) {
        this.showMore = true;
      }
    },
    installOwlCarousel: function(carousel) {
      $(carousel).owlCarousel({
        items: 1,
        autoplay: false,
        loop: true,
        nav: true,
        dots: false,
        responsiveClass: true,
        navText: [
          '<span class="fa fa-chevron-left fa-lg"></span>',
          '<span class="fa fa-chevron-right fa-lg"></span>',
        ],
        onInitialize: function(event) {
          if ($(".owl-carousel .item").length <= 1) {
            loop = false;
          }
        },
        responsive: {
          0: {
            items: 1,
            nav: false,
            margin: 10,
            stagePadding: 60,
          },
          480: {
            items: 3,
            nav: true,
            margin: 12,
            stagePadding: 20,
          },
          768: {
            items: 3,
            stagePadding: 0,
            loop: false,
            margin: 14,
          },
          992: {
            items: 5,
            stagePadding: 0,
            loop: false,
            margin: 12,
          },
        },
      });
    },
    async initializeContentForStart() {
      var vm = this;

      let response = await axios.get(
        `https://rtb.glueapi.io/v1/content?fieldPath=content_type&fieldValue=${
          vm.cat_id
        }&limit=10&idSchemas=205,207,208,209`,
        {
          responseType: "json",
        }
      );

      vm.items = response.data.data;
      var target = document.getElementById(vm.titleCarousel);
      if (vm.items) {
        this.checkIndexForMore();
        Vue.nextTick(
          function() {
            vm.installOwlCarousel(target);
          }.bind(vm)
        );
      }
    },
    async getBgImage() {
      //  backgroundImgDesktop: "",
      // backgroundImgMobile: "",

      var vm = this;

      let response = await axios.get(
        `https://rtb-admin.glueapi.io/v2/asset/s3file?bucket=image&folderName=testing`,
        {
          responseType: "json",
        }
      );

      response.data.data.forEach((element) => {
        if (element.name === "web_banner.png") {
          vm.backgroundImgDesktop = `https://rtb-images.glueapi.io/1200x0/${
            element.key
          }`;
        } else if (element.name === "ios_banner.png") {
          vm.backgroundImgMobile = `https://rtb-images.glueapi.io/560x0/${
            element.key
          }`;
        }
      });
    },
    deviceCheck() {
      if (this.$device.mobile) {
        this.mobile = true;
      } else {
        this.desktop = true;
      }
    },
  },
  beforeMount() {
    setTimeout(
      function() {
        this.initializeContentForStart();
        this.getBgImage();
      }.bind(this),
      1000
    );
  },
  mounted() {
    this.deviceCheck();
  },
};
</script>

<style scoped>
.carousel-main-height-wrapper {
  height: 290px;
}
.main-bg {
  -webkit-background-size: cover !important;
  -moz-background-size: cover !important;
  -o-background-size: cover !important;
  background-size: cover !important;
  background-position: top right !important;
  background-repeat: no-repeat !important;
}
.carousel_title {
  font-size: 22px;
  font-weight: bold;
  line-height: 22px;
  text-align: left;
  color: #fab900;
}
.carousel_more {
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 1.19;
  text-align: left;
  color: #f9b91b;
}
.section-padding {
  margin: 20px 8px 8px;
  height: auto !important;
}

@media only screen and (max-width: 768px) {
  .main-bg {
    background-position: top right !important;
  }

  .carousel-main-height-wrapper {
    height: auto;
  }
}
</style>

<style>
.sponsor-video-content .owl-theme .owl-stage-outer {
  overflow: hidden;
}

@media only screen and (min-width: 992px) {
  .sponsor-video-content .owl-theme .owl-stage-outer:hover {
    overflow: unset;
    max-height: 160px !important;
  }
}

#sponsorRails .owl-prev,
#sponsorRails .owl-next {
  max-height: 100px;
  top: 30px !important;
  width: 40px;
  position: absolute;
}

#sponsorRails .owl-prev,
#sponsorRails .owl-next {
  width: 50px !important;
  height: 50px !important;
}

#sponsorRails .owl-prev span,
.owl-next span {
  color: #fab900 !important;
}

#sponsorRails .owl-prev {
  left: -14px !important;
  background-image: linear-gradient(to right, #000000, rgba(0, 0, 0, 0));
}

#sponsorRails .owl-next {
  right: -14px !important;
  background-image: linear-gradient(to left, #000000, rgba(0, 0, 0, 0));
}

button:focus {
  outline: unset !important;
}

@media only screen and (max-width: 992px) {
  #sponsorRails .owl-prev,
  #sponsorRails .owl-next {
    top: 50px !important;
  }

  #sponsorRails .owl-prev,
  #sponsorRails .owl-next {
    width: 40px !important;
    height: 40px !important;
    font-size: 14px;
  }
}
@media only screen and (max-width: 768px) {
  #sponsorRails .owl-prev,
  #sponsorRails .owl-next {
    top: 40px !important;
  }
}
@media only screen and (max-width: 600px) {
  #sponsorRails .owl-prev,
  #sponsorRails .owl-next {
    top: 32% !important;
  }
}
@media only screen and (max-width: 480px) {
  #sponsorRails .owl-prev,
  #sponsorRails .owl-next {
    top: 25% !important;
  }
}
</style>
